import { OFFER_DURATION_MINUTES, OFFER_END_DATE, OFFER_MODE } from '../data/offer';

const STORAGE_KEY = 'ksp-offer-deadline';

// Devuelve el momento (ms) en que termina la oferta.
// - 'evergreen': cada visitante tiene su propio plazo (por defecto 1 hora) desde su
//   primera visita; se guarda en el navegador para que no se reinicie al recargar.
// - 'fixed': usa la fecha real definida en OFFER_END_DATE.
export function getOfferDeadline(): number {
  if (OFFER_MODE === 'fixed') return new Date(OFFER_END_DATE).getTime();

  const fresh = Date.now() + OFFER_DURATION_MINUTES * 60 * 1000;
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    if (stored && Number.isFinite(stored)) return stored;
    window.localStorage.setItem(STORAGE_KEY, String(fresh));
  } catch {
    // localStorage no disponible: se usa un plazo por sesión
  }
  return fresh;
}
